import React from "react";
import PropTypes from "prop-types";
import {isEmpty} from 'lodash'
import {Section,Columns,Column,Title,Content} from 'bloomer'
import Hero from '../components/hero'
import ContentContainer from './body/content';



const imageExists=(image)=>{
  return image && isEmpty(image.externalSrc || image.src)
}

const ToggledTitle = ({condition,className,title})=>{
  return condition?
    <Title
      style={{marginTop:'1em'}}
      isSize={2}
      className={` has-text-weight-bold is-bold-light ${className}`}
    >
      {title}
    </Title>:null
}



ToggledTitle.propTypes={
  classNames: PropTypes.string,
  condition: PropTypes.bool,
  title: PropTypes.string
}


const SitePageTemplate = ({
  content,
  title,
  helmet,
  image,
  heroClass,
  showHeaderImage,
  contentComponent
         }) => {
  const PageContent = contentComponent || ContentContainer
  return (
    <div>
      <div id="carousel-wrap">
        <Hero
          className={heroClass}
          images={showHeaderImage?[image]:[]}
          getBody={()=>{
            return <ToggledTitle
              title={title}
              className="is-hidden-touch"
              condition={imageExists(image)}
            />
          }}
        />
      </div>
      <Section className={'row'}>
        {helmet || ''}
          <Content>
              <Columns>
                <Column isSize={10} className='is-offset-1'>
                  <ToggledTitle
                    title={title}
                    condition={!imageExists(image)}
                  />
                  <ToggledTitle
                    title={title}
                    className="is-hidden-desktop"
                    condition={imageExists(image) && !showHeaderImage}
                  />
                  {image && image.src && !showHeaderImage &&
                    <figure className="image">
                      <img src={image.src}/>
                    </figure>
                  }
                    <PageContent
                      content={content}
                    />
                </Column>
              </Columns>
          </Content>
      </Section>
    </div>
  );
};

SitePageTemplate.defaultType = {
  showHeaderImage:false
};

SitePageTemplate.propTypes = {
  content: PropTypes.any.isRequired,
  title: PropTypes.string,
  name: PropTypes.string,
  image: PropTypes.object,
  helmet: PropTypes.any,
  showHeaderImage:PropTypes.bool,
  heroClass:PropTypes.string,
}

export default SitePageTemplate;
